import { render } from "./Project2.vue?vue&type=template&id=4c086062&scoped=true"
import script from "./Project2.vue?vue&type=script&lang=js"
export * from "./Project2.vue?vue&type=script&lang=js"

import "./Project2.vue?vue&type=style&index=0&id=4c086062&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c086062"

export default script